module.exports = __webpack_public_path__ + "images/Vision_SS_268883156_75d8fcc.jpg";